import { usePaginationInfo } from './usePaginationInfo';

export interface PaginationInfoProps {
  currentPage: number;
  totalCount: number;
  pageSize: number;
}

export function PaginationInfo({
  currentPage,
  totalCount,
  pageSize,
}: PaginationInfoProps) {
  const paginationInfo = usePaginationInfo({
    currentPage,
    totalCount,
    pageSize,
  });
  return (
    <>
      <div className="px-4">|</div>
      <span
        className="text-sm font-semibold text-gray-900"
        data-testid="pagination-info"
      >
        {paginationInfo}
      </span>
    </>
  );
}
